import { useAuthContext } from "../../context/AuthContext";
import React, { useEffect, useRef, useState } from "react";
import "react-circular-progressbar/dist/styles.css";
import {
  changePassword,
  getBmi,
  getProfile,
  updateAvatar,
  updateUserProfile,
} from "../../api/api";
import { Dialog, RadioGroup, Switch, Tab } from "@headlessui/react";
import Button from "../basic/Button";
import { toast } from "react-toastify";
import {
  BlackTextLinearGradient,
  BlueLinearGradient,
  BlueTextLinearGradient,
  classNames,
  getExpiresInDays,
  showTrailExpireAnnouncement,
  timestampToFormattedDate,
  WhiteLinearGradient,
  WhiteTextLinearGradient,
} from "../../utils/Utils";
import { Icon } from "@iconify/react";
import CustomDialog from "../basic/Dialog";
import IconButton from "../basic/IconButton";
import ImageCropDialog from "./ImageCropDialog";
import GaugeChart from "react-gauge-chart";
import DatePicker from "react-datepicker";
import headerBG from "../../assets/images/ProfileHeadBG.png";
import heroBG from "../../assets/images/Performance_HeroBG.png";
import footerBG from "../../assets/images/Performance_footerBG.png";
import "react-datepicker/dist/react-datepicker.css";
import "./custom.css";
import { useNavigate } from "react-router-dom";

function BMIRange({ name, selected, color }) {
  return (
    <div className="flex flex-row space-x-4 items-center justify-center">
      <div
        className={`${color} w-6 h-6 md:w-8 md:h-8 rounded-full ${
          selected
            ? "border-4 border-white drop-shadow-[0_4px_17px_rgba(0,0,0,0.6)]"
            : ""
        }`}
      />
      <p className={` font-bold text-lg ${BlackTextLinearGradient}`}>{name}</p>
    </div>
  );
}

function ChangePasswordDialog({ show, close }) {
  const [currentPasswrd, setCurrentPassword] = useState();
  const [newPassword, setNewPassword] = useState();
  const [confirmPasswrd, setConfirmPassword] = useState();

  const [passwordInputType, setPasswordInputType] = useState("password");
  const [confirmPasswordInputType, setConfirmPasswordInputType] =
    useState("password");
  const [newPasswordInputType, setNewPasswordInputType] = useState("password");

  async function performChangePassword() {
    const response = await changePassword(currentPasswrd, newPassword);
    if (response.success) {
      toast("Password Updated", { type: "success" });
      close();
    } else {
      toast("Password Update Failed", { type: "error" });
    }
  }
  return (
    <CustomDialog show={show} close={close}>
      <Dialog.Panel
        className={`w-full max-w-xl transform overflow-hidden rounded-2xl p-6 text-left align-middle flex flex-col justify-center shadow-xl transition-all`}
      >
        <div className={`w-full flex justify-end items-end `}>
          <IconButton
            iconComponent={<Icon icon={"akar-icons:cross"} />}
            className={`shadow-3xl flex justify-end ${WhiteLinearGradient} dark:text-primary-white`}
            onClick={() => close()}
          />
        </div>
        <p className="text-2xl font-bold text-center text-gray-900 dark:text-primary-white    ">
          Change Password
        </p>

        <div className="mt-5 px-4 py-3 flex flex-row  rounded-lg items-center  border-[1px] bg-transparent border-gray-300 ">
          <input
            className="bg-transparent flex flex-1  placeholder-[#667085] outline-none"
            placeholder="Current Password"
            value={currentPasswrd}
            type={passwordInputType}
            onChange={(e) => {
              if (e.target.value.length > 0)
                if (!e.target.value.match(/^[\S]+$/)) {
                  toast("Spaces are not allowed in password");
                } else {
                  setCurrentPassword(e.target.value);
                }
              else {
                setCurrentPassword("");
              }
            }}
          />
          <Icon
            icon={
              passwordInputType === "password"
                ? "akar-icons:eye"
                : "akar-icons:eye-slashed"
            }
            color="#667085"
            onClick={() => {
              setPasswordInputType(
                passwordInputType === "password" ? "text" : "password"
              );
            }}
            className="w-5 h-5"
          />
        </div>
        <div className="mt-3 px-4 py-3 flex flex-row  rounded-lg items-center  border-[1px] bg-transparent border-gray-300 ">
          <input
            className="bg-transparent flex flex-1  placeholder-[#667085] outline-none"
            placeholder="New Password"
            value={newPassword}
            type={newPasswordInputType}
            onChange={(e) => {
              if (e.target.value.length > 0)
                if (!e.target.value.match(/^[\S]+$/)) {
                  toast("Spaces are not allowed in password");
                } else {
                  setNewPassword(e.target.value);
                }
              else {
                setNewPassword("");
              }
            }}
          />
          <Icon
            icon={
              newPasswordInputType === "password"
                ? "akar-icons:eye"
                : "akar-icons:eye-slashed"
            }
            color="#667085"
            onClick={() => {
              setNewPasswordInputType(
                newPasswordInputType === "password" ? "text" : "password"
              );
            }}
            className="w-5 h-5"
          />
        </div>

        <div className="mt-3 px-4 py-3 flex flex-row  rounded-lg items-center  border-[1px] bg-transparent border-gray-300 ">
          <input
            className="bg-transparent flex flex-1  placeholder-[#667085] outline-none"
            placeholder="Confirm Password"
            value={confirmPasswrd}
            type={confirmPasswordInputType}
            onChange={(e) => {
              if (e.target.value.length > 0)
                if (!e.target.value.match(/^[\S]+$/)) {
                  toast("Spaces are not allowed in password");
                } else {
                  setConfirmPassword(e.target.value);
                }
              else {
                setConfirmPassword("");
              }
            }}
          />
          <Icon
            icon={
              confirmPasswordInputType === "password"
                ? "akar-icons:eye"
                : "akar-icons:eye-slashed"
            }
            color="#667085"
            onClick={() => {
              setConfirmPasswordInputType(
                confirmPasswordInputType === "password" ? "text" : "password"
              );
            }}
            className="w-5 h-5"
          />
        </div>
        <Button
          onClick={() => {
            if (newPassword == confirmPasswrd) performChangePassword();
            else toast("Password do not match");
          }}
          type="primary"
          className={"self-center mt-6"}
        >
          Done
        </Button>
      </Dialog.Panel>
    </CustomDialog>
  );
}

function ProfileDetailItem({ title, value, className }) {
  return (
    <div className="flex flex-col md:flex-row md:space-x-10 md:items-center">
      <p className="font-light text-sm font-noto-sans text-primary-white uppercase flex md:basis-40">
        {title} :
      </p>
      <p
        className={`font-medium text-md md:text-lg ${BlackTextLinearGradient} ${className}`}
      >
        {value ? value : "-"}
      </p>
    </div>
  );
}

function EditProfileDialog({ show, close }) {
  const auth = useAuthContext();
  const [name, setName] = useState(auth.state.user.fullname);
  const [dob, setDob] = useState(
    auth.state.user.dob
      ? new Date(
          auth.state.user.dob?.split("/")[2],
          auth.state.user.dob?.split("/")[1] - 1,
          auth.state.user.dob?.split("/")[0]
        )
      : null
  );
  const [height, setHeight] = useState(auth.state.user.height);
  const [weight, setWeight] = useState(auth.state.user.weight);
  const [heightUnit, setHeightUnit] = useState("cm");
  const [weightUnit, setWeightUnit] = useState("KG");
  const [feet, setFeet] = useState(Math.floor(height / 2.54 / 12));
  const [inch, setInch] = useState(
    (height / 2.54 - 12 * Math.floor(height / 2.54 / 12)).toFixed(2)
  );
  return (
    <CustomDialog show={show} close={close}>
      <Dialog.Panel
        className={`w-full max-w-2xl transform overflow-hidden rounded-2xl p-6 text-left align-middle shadow-xl transition-all`}
        style={{
          backgroundImage: `url(${headerBG})`,
          backgroundSize: "cover",
        }}
      >
        <div className="flex flex-row  items-center">
          <p
            className={`flex flex-1 font-medium text-xl ${BlackTextLinearGradient}`}
          >
            Edit Details
          </p>
          <IconButton
            iconComponent={<Icon icon={"akar-icons:cross"} />}
            className={`shadow-3xl flex justify-end ${WhiteLinearGradient} dark:text-primary-white`}
            onClick={() => close()}
          />
        </div>
        <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
          <p className="font-medium basis-3/12 text-black dark:text-white uppercase">
            Name
          </p>
          <input
            className="px-4 py-3  rounded-lg border-[1px] dark:text-primary-white placeholder-[#667085] bg-transparent border-gray-300 "
            placeholder="Name"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </div>
        <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
          <p className="font-medium basis-3/12 text-black dark:text-white uppercase">
            Birthday
          </p>
          <div className="flex flex-row space-x-2 ">
            <DatePicker
              selected={dob}
              onChange={(date) => setDob(date)}
              dateFormat="dd/MM/yyyy"
              allowSameDay={false}
              endDate={new Date()}
              maxDate={new Date()}
              placeholderText="Date of Birth"
              closeOnScroll={false}
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              className="flex flex-1 px-4 w-full py-3 rounded-lg border-[1px] placeholder-[#667085] bg-transparent border-gray-300 text-black dark:text-white"
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row mt-4 md:items-center md:space-x-5">
          <p className="font-medium basis-3/12 text-black dark:text-white text-lg">
            Height
          </p>
          <div className="flex flex-row items-center md:space-x-2">
            {heightUnit == "cm" && (
              <input
                className="px-4 py-3 w-24 rounded-lg border-[1px] placeholder-customGray-700 text-black dark:text-white bg-transparent border-customGray-700 "
                placeholder={heightUnit}
                value={height}
                onChange={(e) => {
                  setHeight(e.target.value);
                }}
                type="number"
              />
            )}
            <div className="flex flex-col md:flex-row w-full gap-5">
              {heightUnit == "ft" && (
                <input
                  className="px-4 py-3 w-24 rounded-lg border-[1px] placeholder-customGray-700 text-black dark:text-white bg-transparent border-customGray-700 "
                  placeholder={"Ft."}
                  value={feet}
                  onChange={(e) => {
                    setFeet(e.target.value);

                    setHeight(
                      (30.48 * e.target.value + inch * 2.54).toFixed(2)
                    );
                  }}
                  type="number"
                />
              )}
              {heightUnit == "ft" && (
                <input
                  className="px-4 py-3 w-24 rounded-lg border-[1px] placeholder-customGray-700 text-black dark:text-white bg-transparent border-customGray-700 "
                  placeholder={"Inc."}
                  value={inch}
                  onChange={(e) => {
                    setInch(e.target.value);
                    setHeight(
                      (feet * 30.54 + e.target.value * 2.54).toFixed(2)
                    );
                  }}
                  type="number"
                />
              )}
            </div>
            <div className="flex flex-row items-center gap-5 mt-5 md:mt-0">
              <p
                className={`${
                  heightUnit == "cm"
                    ? "text-primary-neonGreen"
                    : "text-primary-gray"
                } font-medium`}
              >
                CENT.
              </p>
              <Switch
                checked={heightUnit == "ft"}
                onChange={(checked) => {
                  if (checked) {
                    setHeightUnit("ft");
                  } else {
                    setHeightUnit("cm");
                  }

                  if (checked) {
                    setFeet(Math.floor(height / 2.54 / 12));
                    setInch(
                      (
                        height / 2.54 -
                        12 * Math.floor(height / 2.54 / 12)
                      ).toFixed(2)
                    );
                  }
                }}
                className={`bg-primary-neonGreen
          relative items-center inline-flex h-[20px] w-[35px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
              >
                <span
                  aria-hidden="true"
                  className={`${
                    heightUnit == "ft" ? "translate-x-4" : "-translate-x-2"
                  }
            pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
                >
                  <span
                    aria-hidden="true"
                    className={`${
                      heightUnit == "ft" ? "translate-x-0" : "-translate-x-0"
                    }
            pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
                  />
                </span>
              </Switch>

              <p
                className={`${
                  heightUnit == "ft"
                    ? "text-primary-neonGreen"
                    : "text-primary-gray"
                } font-medium`}
              >
                FT.
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-col md:flex-row mt-4 md:items-center md:space-x-5">
          <p className="font-medium basis-3/12 text-black dark:text-white text-lg">
            Weight
          </p>
          <div className="flex flex-row items-center space-x-2">
            <input
              className="px-4 py-3 w-24 rounded-lg border-[1px] placeholder-customGray-700 text-black dark:text-white bg-transparent border-customGray-700 "
              placeholder={weightUnit}
              value={weight}
              onChange={(e) => {
                setWeight(e.target.value);
              }}
              type="number"
            />
            <div className="flex flex-row items-center gap-5 mt-5 md:mt-0 sm:ml-6">
              <p
                className={`${
                  weightUnit == "KG"
                    ? "text-primary-neonGreen"
                    : "text-primary-gray"
                } font-medium`}
              >
                KG.
              </p>
              <Switch
                checked={weightUnit == "lbs"}
                onChange={(checked) => {
                  if (checked) {
                    setWeightUnit("lbs");
                  } else {
                    setWeightUnit("KG");
                  }
                  if (checked) {
                    setWeight((weight / 0.453592).toFixed(2));
                  } else {
                    setWeight((weight * 0.453592).toFixed(2));
                  }
                }}
                className={`bg-primary-neonGreen
          relative items-center inline-flex h-[20px] w-[35px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
              >
                <span
                  aria-hidden="true"
                  className={`${
                    weightUnit == "lbs" ? "translate-x-4" : "-translate-x-2"
                  }
            pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
                >
                  <span
                    aria-hidden="true"
                    className={`${
                      weightUnit == "lbs" ? "translate-x-0" : "-translate-x-0"
                    }
            pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
                  />
                </span>
              </Switch>
              <p
                className={`${
                  weightUnit == "lbs"
                    ? "text-primary-neonGreeen"
                    : "text-primary-gray"
                } font-medium`}
              >
                LBS.
              </p>
            </div>
          </div>
        </div>
        <div className="flex justify-center">
          <Button
            onClick={async () => {
              if (!height || height < 0) {
                toast("Height is required", { type: "error" });
              } else if (
                heightUnit != "cm" &&
                (feet < 2 || feet > 7 || inch < 0 || inch > 12)
              ) {
                toast("Height must be between 2 and 7 ft.", {
                  type: "error",
                });
              } else if (heightUnit != "ft" && (height < 2 || height > 213)) {
                toast("Height must be between 30 cm and 213 cm.", {
                  type: "error",
                });
              } else if (!weight) {
                toast("Weight is required", { type: "error" });
              } else if (weight <= 1) {
                toast("Weight must be greater than 1", { type: "error" });
              } else if (weightUnit == "lbs" && (weight < 4 || weight > 331)) {
                toast("Weight must be between 4 and 331 lbs.", {
                  type: "error",
                });
              } else if (weightUnit != "lbs" && (weight < 4 || weight > 150)) {
                toast("Weight must be between 4 and 150 kgs.", {
                  type: "error",
                });
              } else if (dob == null) {
                toast("Invalid Date of Birth", { type: "error" });
              } else {
                let response = await getBmi({
                  height: height,
                  weight: weight,
                  dob: dob
                    .toLocaleString("en-us", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                    .replace(/(\d+)\/(\d+)\/(\d+)/, "$2/$1/$3"),
                });
                const data = {
                  update: JSON.stringify({
                    fullname: name,
                  }),
                };
                response = await updateUserProfile(data);
                auth.updateUser();
                toast("Profile details updated");
                close();
              }
            }}
            type="primary"
            className={"w-2/5 mt-6"}
          >
            Done
          </Button>
        </div>
      </Dialog.Panel>
    </CustomDialog>
  );
}

const MemoizedBmiGauge = React.memo(BmiGauge);

function BmiGauge({ bmi }) {
  return (
    <GaugeChart
      id="bmi-chart"
      nrOfLevels={4}
      colors={["#F6D738", "#34E130", "#FE654F", "#FF0000"]}
      arcPadding={0}
      cornerRadius={0}
      Radius={20}
      needleBaseColor={"#FFFFFF"}
      needleColor={"#FFFFFF"}
      // needleShape= {"Pointer"}
      hideText
      percent={bmi ? (bmi / 50 > 1 ? 1 : bmi / 50) : 0}
      arcsLength={[0.25, 0.2, 0.2, 0.2]}
    />
  );
}

function BMIComponent({ profile, onUpdateProfile }) {
  const auth = useAuthContext();

  const [height, setHeight] = useState(auth.state.user.height);
  const [weight, setWeight] = useState(auth.state.user.weight);
  const [heightUnit, setHeightUnit] = useState("cm");
  const [weightUnit, setWeightUnit] = useState("KG");
  const [feet, setFeet] = useState(Math.floor(height / 2.54 / 12));
  const [inch, setInch] = useState(
    (height / 2.54 - 12 * Math.floor(height / 2.54 / 12)).toFixed(2)
  );
  return (
    <div
      className={`dark:border-[#68696B33] border-[1px] rounded-xl py-3 px-6`}
      style={{
        backgroundImage: `url(${heroBG})`,
        backgroundSize: "cover",
      }}
    >
      <div className="flex flex-col md:flex-row my-3 md:my-7 md:space-x-5">
        <div className="flex flex-col flex-1">
          <div className="flex flex-row space-x-10">
            <p
              type="primary"
              className={"hidden md:block max-h-max"}
              onClick={async () => {
                if (!height || height < 0) {
                  toast("Height is required", { type: "error" });
                } else if (
                  heightUnit != "cm" &&
                  (feet < 2 || feet > 7 || inch < 0 || inch > 12)
                ) {
                  toast("Height must be between 2 and 7 ft.", {
                    type: "error",
                  });
                } else if (heightUnit != "ft" && (height < 2 || height > 213)) {
                  toast("Height must be between 30 cm and 213 cm.", {
                    type: "error",
                  });
                } else if (!weight) {
                  toast("Weight is required", { type: "error" });
                } else if (weight <= 1) {
                  toast("Weight must be greater than 1", { type: "error" });
                } else if (
                  weightUnit == "lbs" &&
                  (weight < 4 || weight > 331)
                ) {
                  toast("Weight must be between 4 and 331 lbs.", {
                    type: "error",
                  });
                } else if (
                  weightUnit != "lbs" &&
                  (weight < 4 || weight > 150)
                ) {
                  toast("Weight must be between 4 and 150 kgs.", {
                    type: "error",
                  });
                } else {
                  const response = await getBmi({
                    height: height,
                    weight: weight,
                    dob: profile.dob,
                  });
                  if (response.bmi) {
                    toast("BMR updated");
                  } else {
                    toast("BMR udpate failed");
                  }
                  onUpdateProfile();
                }
              }}
            >
              <p
                className={`text-lg font-bold mb-5 px-6 ${BlackTextLinearGradient}`}
              >
                Your BMI
              </p>
            </p>
          </div>
          <div className="flex flex-col md:flex-row mt-4 md:items-center md:space-x-2">
            <p className="font-light basis-3/12 text-black dark:text-white text-sm lg:px-8 px-4">
              Height
            </p>
            <div className="flex flex-row items-center md:space-x-5 lg:pl-8">
              {heightUnit == "cm" && (
                <input
                  className="px-4 py-3 w-28 h-10 rounded-lg border-[1px] placeholder-customGray-700 text-black dark:text-white bg-transparent border-customGray-700 "
                  placeholder={heightUnit}
                  value={height}
                  onChange={(e) => {
                    setHeight(e.target.value);
                  }}
                  type="number"
                />
              )}
              <div className="flex flex-col md:flex-row w-full gap-2">
                {heightUnit == "ft" && (
                  <input
                    className="px-6 py-3 w-28 h-10 rounded-md border-[1px] placeholder-customGray-700 text-black dark:text-white bg-transparent border-customGray-700 "
                    placeholder={"Ft./INC"}
                    value={feet}
                    onChange={(e) => {
                      setFeet(e.target.value);

                      setHeight(
                        (30.48 * e.target.value + inch * 2.54).toFixed(2)
                      );
                    }}
                    type="number"
                  />
                )}
                {heightUnit == "ft" && (
                  <input
                    className="px-10 py-3 w-28 h-10 rounded-lg border-[1px] placeholder-customGray-700 text-black dark:text-white bg-transparent border-customGray-700 "
                    placeholder={"Inc."}
                    value={inch}
                    onChange={(e) => {
                      setInch(e.target.value);
                      setHeight(
                        (feet * 30.54 + e.target.value * 2.54).toFixed(2)
                      );
                    }}
                    type="number"
                  />
                )}
              </div>
              <div className="flex flex-row items-center gap-4 mt-5 md:mt-0">
                <p
                  className={`${
                    heightUnit == "cm"
                      ? "text-primary-white"
                      : "text-primary-gray"
                  } font-medium text-sm`}
                >
                  CENT.
                </p>
                <Switch
                  checked={heightUnit == "ft"}
                  onChange={(checked) => {
                    if (checked) {
                      setHeightUnit("ft");
                    } else {
                      setHeightUnit("cm");
                    }

                    if (checked) {
                      setFeet(Math.floor(height / 2.54 / 12));
                      setInch(
                        (
                          height / 2.54 -
                          12 * Math.floor(height / 2.54 / 12)
                        ).toFixed(2)
                      );
                    }
                  }}
                  className={`bg-primary-neonGreen
          relative items-center inline-flex h-[20px] w-[35px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
                >
                  <span
                    aria-hidden="true"
                    className={`${
                      heightUnit == "ft" ? "translate-x-4" : "-translate-x-2"
                    }
            pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
                  >
                    <span
                      aria-hidden="true"
                      className={`${
                        heightUnit == "ft" ? "translate-x-0" : "-translate-x-0"
                      }
            pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
                    />
                  </span>
                </Switch>
                <p
                  className={`${
                    heightUnit == "ft"
                      ? "text-primary-neonGreen"
                      : "text-primary-gray"
                  } font-medium text-sm`}
                >
                  FT.
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row mt-4 md:items-center md:space-x-2">
            <p className="font-light basis-3/12 text-black dark:text-white text-sm lg:px-8 px-4 ">
              Weight
            </p>
            <div className="flex flex-row items-center md:space-x-12 lg:pl-8">
              <div className="flex flex-col md:flex-row w-full gap-2">
                <input
                  className="px-4 py-3  w-28 h-10 rounded-lg border-[1px] placeholder-customGray-700 text-black dark:text-white bg-transparent border-customGray-700 "
                  placeholder={weightUnit}
                  value={weight}
                  onChange={(e) => {
                    setWeight(e.target.value);
                  }}
                  type="number"
                />
              </div>
              <div className="flex flex-row items-center gap-4 mt-5 md:mt-0">
                <p
                  className={`${
                    weightUnit == "KG"
                      ? "text-primary-white"
                      : "text-primary-gray"
                  } font-medium text-sm flex flex-justify-center sm:pl-0`}
                >
                  KG.
                </p>
                <Switch
                  checked={weightUnit == "lbs"}
                  onChange={(checked) => {
                    if (checked) {
                      setWeightUnit("lbs");
                    } else {
                      setWeightUnit("KG");
                    }
                    if (checked) {
                      setWeight((weight / 0.453592).toFixed(2));
                    } else {
                      setWeight((weight * 0.453592).toFixed(2));
                    }
                  }}
                  className={`bg-primary-neonGreen
          relative items-center inline-flex h-[20px] w-[35px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
                >
                  <span
                    aria-hidden="true"
                    className={`${
                      weightUnit == "lbs" ? "translate-x-4" : "-translate-x-2"
                    }
            pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
                  >
                    <span
                      aria-hidden="true"
                      className={`${
                        weightUnit == "lbs" ? "translate-x-0" : "-translate-x-0"
                      }
            pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
                    />
                  </span>
                </Switch>
                <p
                  className={`${
                    weightUnit == "lbs"
                      ? "text-primary-neonGreen"
                      : "text-primary-gray"
                  } font-medium text-sm`}
                >
                  LBS.
                </p>
              </div>
            </div>
          </div>
          {/* <Button
            type="primary"
            className={
              "block md:hidden flex max-h-max items-center space-x-3 mt-5"
            }
            onClick={async () => {
              if (!height || height < 0) {
                toast("Height is required", { type: "error" });
              } else if (
                heightUnit != "cm" &&
                (feet < 2 || feet > 7 || inch < 0 || inch > 12)
              ) {
                toast("Height must be between 2 and 7 ft.", {
                  type: "error",
                });
              } else if (heightUnit != "ft" && (height < 2 || height > 213)) {
                toast("Height must be between 30 cm and 213 cm.", {
                  type: "error",
                });
              } else if (!weight) {
                toast("Weight is required", { type: "error" });
              } else if (weight <= 1) {
                toast("Weight must be greater than 1", { type: "error" });
              } else if (weightUnit == "lbs" && (weight < 4 || weight > 331)) {
                toast("Weight must be between 4 and 331 lbs.", {
                  type: "error",
                });
              } else if (weightUnit != "lbs" && (weight < 4 || weight > 150)) {
                toast("Weight must be between 4 and 150 kgs.", {
                  type: "error",
                });
              } else {
                console.log({ height, weight });

                const response = await getBmi({
                  height: height,
                  weight: weight,
                  dob: profile.dob,
                });
                if (response.bmi) {
                  toast("BMR updated");
                } else {
                  toast("BMR udpate failed");
                }
                onUpdateProfile();
              }
            }}
          >
            <p className={`font-bold text-xs`}>Update Data</p>
            <Icon icon="jam:refresh-reverse" className="h-3 w-auto flex align-center" />
          </Button> */}
        </div>
        <div
          className={`block md:hidden min-h-[1px] min-w-full bg-gradient-to-l my-10 from-primary-white via-primary-black to-primary-white`}
        ></div>
        <div
          className={`min-w-[1px] min-h-full bg-gradient-to-b from-primary-white via-primary-black to-primary-white`}
        ></div>

        <div className="flex flex-col text-xl font-bold  w-full md:w-32 basis-1/4">
          {/* <p className={`text-xl font-medium mb-5 ${BlackTextLinearGradient}`}>
            Your BMI
          </p> */}
          {/* <div className="flex justify-end flex-row items-end lg:-mt-10 mb-6 text-primary-gray space-x-2 space-y-3">
            <p className={`font-bold text-xs`}>Update Data</p>
            <Icon icon="jam:refresh-reverse" className="h-4 w-auto" />
          </div> */}
          <p
            type="primary"
            className="flex justify-end flex-row items-end lg:-mt-10 mb-6 text-primary-gray space-x-2 space-y-3"
            onClick={async () => {
              if (!height || height < 0) {
                toast("Height is required", { type: "error" });
              } else if (
                heightUnit != "cm" &&
                (feet < 2 || feet > 7 || inch < 0 || inch > 12)
              ) {
                toast("Height must be between 2 and 7 ft.", {
                  type: "error",
                });
              } else if (heightUnit != "ft" && (height < 2 || height > 213)) {
                toast("Height must be between 30 cm and 213 cm.", {
                  type: "error",
                });
              } else if (!weight) {
                toast("Weight is required", { type: "error" });
              } else if (weight <= 1) {
                toast("Weight must be greater than 1", { type: "error" });
              } else if (weightUnit == "lbs" && (weight < 4 || weight > 331)) {
                toast("Weight must be between 4 and 331 lbs.", {
                  type: "error",
                });
              } else if (weightUnit != "lbs" && (weight < 4 || weight > 150)) {
                toast("Weight must be between 4 and 150 kgs.", {
                  type: "error",
                });
              } else {
                console.log({ height, weight });

                const response = await getBmi({
                  height: height,
                  weight: weight,
                  dob: profile.dob,
                });
                if (response.bmi) {
                  toast("BMR updated");
                } else {
                  toast("BMR udpate failed");
                }
                onUpdateProfile();
              }
            }}
          >
            <p className={`font-bold text-xs`}>Update Data</p>
            <Icon icon="jam:refresh-reverse" className="h-4 w-auto" />
          </p>

          <MemoizedBmiGauge bmi={profile.bmi} />
          <p className="text-primary-black dark:text-primary-white text-md text-center">
            {profile.bmi}
          </p>
          <BMIRange
            name={
              profile.bmi > 30
                ? "Obese"
                : profile.bmi >= 25
                ? "Over Weight"
                : profile.bmi >= 18.5
                ? "Healthy"
                : "Under Weight"
            }
            color={
              profile.bmi > 30
                ? "bg-[#ED2114] text-sm"
                : profile.bmi >= 25
                ? "bg-gradient-to-bl from-[#F27128] to-[#E1AF30E8] text-sm"
                : profile.bmi >= 18.5
                ? "bg-gradient-to-bl from-[#34E130] to-[#30A1E1E8] text-sm"
                : "bg-gradient-to-bl from-[#E1CF30] to-[#C8E130E8] text-sm"
            }
          />
        </div>
      </div>
    </div>
  );
}

function ProfilePage() {
  const auth = useAuthContext();
  const navigate = useNavigate();

  const [profile, setProfile] = useState({});
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [showEditProfile, setShowEditProfile] = useState(false);
  const [showImageCropper, setShowImageCropper] = useState(false);
  const [profilePicture, setProfilePicture] = useState();
  const imagePickerRef = useRef();
  console.log("auth.state.user : " + auth.state.user);

  async function updateProfile() {
    let response = await getProfile();
    console.log(response);
    if (response) {
      setProfile(response);
    } else {
      // toast("Error fetching profile details", { type: "error" });
    }
  }

  async function uploadAvatar(image) {
    let data = new FormData();
    data.append("avatar", image);
    const response = await updateAvatar(data);
    auth.updateUser();
    if (response.success) {
      toast("Avatar Updated");
      return true;
    } else {
      toast("Avatar update failed. Try a different image");
      return false;
    }
  }

  useEffect(() => {
    updateProfile();
    // uploadAvatar();
    // updateV3Profile()
  }, []);

  return (
    <div
      className={`w-full h-full px-10 py-12 lg:px-52 2xl:px-80 space-y-8`}
      id="cover"
    >
      <ImageCropDialog
        show={showImageCropper}
        close={async (croppedImageBlob) => {
          setShowImageCropper(false);
          const croppedImageUrl = window.URL.createObjectURL(croppedImageBlob);
          const file = new File([croppedImageBlob], "image.png", {
            type: croppedImageBlob.type,
          });
          const success = await uploadAvatar(file);
        }}
        image={profilePicture}
        aspectRatio={1}
      />

      <div
        // className="flex flex-col md:flex-row md:items-start justify-start rounded-lg"
        className="grid lg:grid-cols-3 md:grid-cols-3  grid-cols-1 rounded-lg px-10 md-pt-0 py-6"
        style={{
          backgroundImage: `url(${headerBG})`,
          backgroundSize: "cover",
        }}
      >
        <div
          className="flex lg:justify-start md:justify-start justify-center items-center "
          // className="relative grid lg:py-10 md:py-8 lg:pl-0 md:pl-0 sm:pl-12 sm:-py-20 px-5 py-28 2xl:px-80"
          onClick={() => {
            console.log("click");
            imagePickerRef.current.click();
          }}
        >
          {auth.state.user.avatar ? (
            <img
              src={auth.state.user.avatar}
              className="rounded-full w-40 h-40 mt-0 "
            />
          ) : (
            <div
              className={`flex items-center justify-center ${BlueLinearGradient} rounded-full md:h-40 md:w-40 h-28 w-28`}
              // className={`${BlueLinearGradient} flex items-center justify-center rounded-full h-40 w-40 ml-10 py-16`}
            >
              <p className={`font-medium text-5xl ${WhiteTextLinearGradient}`}>
                {auth.state.user.fullname[0]}
              </p>
            </div>
          )}
          {/* <Icon
            icon="clarity:edit-line"
            className={`absolute bottom-2 right-5 bg-primary-blue w-8 h-8 p-2 rounded-full text-white`}
            onClick={() => {
              imagePickerRef.current.click();
            }}
          /> */}
          <input
            type="file"
            id="file"
            ref={imagePickerRef}
            className="hidden cursor-pointer"
            onChange={(e) => {
              const image = e.target.files[0];
              if (image) {
                setProfilePicture(image);
                setShowImageCropper(true);
              }
            }}
          />
        </div>

        <div className="flex items-center md::justify-start justify-center flex-col md:-ml-80 md:py-16 ml-0 py-2 pt-5">
          <p className="text-black dark:text-[#FFFFFF] font-medium text-lg md:text-xl font-poppins">
            {auth.state.user.fullname}
          </p>
          <p className="text-[#C1C1C1] text-sm font-sans md:ml-6 ml-0">
            {auth.state.user.email}
          </p>
          <p className="text-[#C1C1C1] text-xs font-open-sans md:ml-6 ml-0">
            Joined on {timestampToFormattedDate(auth.state.user.createdAt)}
          </p>
        </div>

        <div className="flex flex-row lg:justify-start md:justify-center justify-center items-center sm:justify-center lg:space-x-12 space-x-4 lg:px-0 px-4 sm:py-4 lg:-ml-6">
          <div
            // className="grid grid-rows-2 gap-2 my-10"
            className="flex flex-col items-center space-y-2"
          >
            <p className="flex justify-center items-center">
              <Icon
                icon="bi:lightning-fill"
                className="h-8 w-auto text-[#48B795]"
              />
            </p>
            <span className="flex justify-center items-center text-white text-xs font-medium">
              {profile.streak}
            </span>
          </div>
          <p className="grid grid-rows-2 gap-2">
            <p className="flex justify-center items-center">
              <Icon
                icon="ic:twotone-access-time-filled"
                className="h-8 w-auto text-[#48B795]"
              />
            </p>
            <p className="flex justify-center items-center text-white text-xs font-medium">
              {profile.timespent}
            </p>
          </p>
          <p className="grid grid-rows-2 gap-2">
            <p className="flex justify-center items-center">
              <Icon
                icon="mdi:fire"
                className="h-8 w-auto text-primary-orange"
              />
            </p>
            <p className="flex justify-center items-center text-white text-xs font-medium">
              {profile.calories}
            </p>
          </p>
          <p className="grid grid-rows-2 gap-4 lg:pt-2 pt-1">
            <p className="flex justify-center items-center pt-4">
              <p className=" text-[#D93942] text-xl font-bold">
                {profile.exe_done}
              </p>
            </p>
            <p className="text-white text-xs font-medium inline-block align-middle">
              moves
            </p>
          </p>
        </div>
      </div>

      <BMIComponent
        profile={profile}
        onUpdateProfile={() => {
          updateProfile();
          auth.updateUser();
        }}
      />
      <div
        className={
          "border-[#B6BCDA80] dark:border-[#68696B33] border-[1px]  rounded-xl p-4 md:p-9"
        }
        style={{
          backgroundImage: `url(${footerBG})`,
          backgroundSize: "cover",
        }}
      >
        <ChangePasswordDialog
          show={showChangePassword}
          close={() => setShowChangePassword(false)}
        />
        <EditProfileDialog
          show={showEditProfile}
          close={() => {
            updateProfile();
            setShowEditProfile(false);
          }}
        />
        <div className="flex flex-row items-center space-x-2 md:space-x-8">
          <p
            className={`flex flex-1 px-4 py-3 font-bold font-poppins text-xl ${BlackTextLinearGradient}`}
          >
            Profile Details
          </p>
          {/* {auth.state?.user?.verifiedThrough == "email" && (
          <Button
            type="outline"
            className={
              "md:block flex items-center space-x-3 border-primary-black dark:border-primary-white"
            }
            onClick={() => setShowChangePassword(true)}
          >
            <p className={`${BlackTextLinearGradient} font-bold`}>
              Change Password
            </p>
          </Button>
          )} */}

          <div
            type="primary"
            className={
              "  flex items-center space-x-1 lg:-mt-16 mt-10 lg:-mr-20 -mr-10"
            }
            onClick={() => setShowEditProfile(true)}
          >
            <Icon
              icon="clarity:edit-line"
              className="h-4 w-auto text-primary-gray"
            />
            <p
              className={`text-xs text-primary-gray font-light flex justify-end`}
            >
              edit
            </p>
          </div>
        </div>

        <div className="flex flex-col py-5 md:p-5 space-y-5">
          <ProfileDetailItem
            title={"First Name"}
            value={auth.state.user.fullname.split(" ").slice(0, 1)}
          />
          <ProfileDetailItem
            title={"Last Name"}
            value={auth.state.user.fullname.split(" ").slice(1)}
          />
          <ProfileDetailItem title={"Email"} value={auth.state.user.email} />
          <ProfileDetailItem
            title={"Phone No."}
            value={auth.state.user.mobile}
          />
          <ProfileDetailItem
            title={"Password"}
            value={
              <p
                type="outline"
                className={"md:block flex items-center space-x-3"}
                onClick={() => setShowChangePassword(true)}
              >
                <p className={`text-gray-500`}>Change Password</p>
              </p>
            }
          />
          <ProfileDetailItem title={"Birthday"} value={auth.state.user.dob} />
          <ProfileDetailItem
            title={"Gender"}
            value={auth.state.user.gender}
            className="capitalize"
          />
          <ProfileDetailItem
            title={"Height"}
            value={auth.state.user.height + " cm"}
          />
          <ProfileDetailItem
            title={"Weight"}
            // value={auth.state.user.weight + " kg"}
            value={auth.state.user.weight + " kg"}
          />
          <ProfileDetailItem
            title={"Fitness Level"}
            value={auth.state.user.fitnessLevel}
          />
          {/* <ProfileDetailItem
            title={"Goal"}
            value={
              auth.state.user.goal == 0
                ? "Starting Out"
                : auth.state.user.goal == 1
                ? "Casual Gym Goer"
                : auth.state.user.goal == 2
                ? "Fitness Freak"
                : ""
            }
          /> */}
          <ProfileDetailItem
            title={"Goal"}
            value={profile.goal}
            className="uppercase"
          />
        </div>

        {auth.state?.user?.verifiedThrough == "email" && (
          <div className="block md:hidden">
            <Button
              type="outline"
              className={
                " flex items-center space-x-3 border-primary-black dark:border-primary-white"
              }
              onClick={() => setShowChangePassword(true)}
            >
              <p className={`${BlackTextLinearGradient} font-bold`}>
                Change Password
              </p>
            </Button>
          </div>
        )}
      </div>
      {/* {showTrailExpireAnnouncement(auth.state.user) && (
        <div
          className={`flex flex-row justify-center items-center space-x-4 bg-primary-neonGreen rounded-xl p-4 md:p-9`}
        >
          <p className="text-white text-xl">
            {getExpiresInDays(auth.state.user.expiresAt) <= 0
              ? "Your Plan has expired"
              : `Your ${
                  auth.state.user.trail ? "free" : ""
                } plan expires in ${getExpiresInDays(
                  auth.state.user.expiresAt
                )} Days`}
          </p>
          <div
            type="outline"
            className="text-primary-gray text-xs font-light"
            onClick={() => navigate("/subscription")}
          >
            <p className="text-white">Edit</p>
          </div>
        </div>
      )} */}
    </div>
  );
}

export default ProfilePage;

//   ******** OLD PROFILE DESIGN ********
// import { useAuthContext } from "../../context/AuthContext";
// import React, { useEffect, useRef, useState } from "react";
// import "react-circular-progressbar/dist/styles.css";
// import {
//   changePassword,
//   getBmi,
//   getProfile,
//   updateAvatar,
//   updateUserProfile,
// } from "../../api/api";
// import { Dialog, RadioGroup, Switch, Tab } from "@headlessui/react";
// import Button from "../basic/Button";
// import { toast } from "react-toastify";
// import {
//   BlackTextLinearGradient,
//   BlueLinearGradient,
//   BlueTextLinearGradient,
//   classNames,
//   getExpiresInDays,
//   showTrailExpireAnnouncement,
//   timestampToFormattedDate,
//   WhiteLinearGradient,
//   WhiteTextLinearGradient,
// } from "../../utils/Utils";
// import { Icon } from "@iconify/react";
// import CustomDialog from "../basic/Dialog";
// import IconButton from "../basic/IconButton";
// import ImageCropDialog from "./ImageCropDialog";
// import GaugeChart from "react-gauge-chart";
// import DatePicker from "react-datepicker";

// import "react-datepicker/dist/react-datepicker.css";
// import { useNavigate } from "react-router-dom";

// function BMIRange({ name, selected, color }) {
//   return (
//     <div className="flex flex-row space-x-4 items-center justify-center">
//       <div
//         className={`${color} w-6 h-6 md:w-8 md:h-8 rounded-full ${selected
//           ? "border-4 border-white drop-shadow-[0_4px_17px_rgba(0,0,0,0.6)]"
//           : ""
//           }`}
//       />
//       <p className={` font-bold text-lg ${BlackTextLinearGradient}`}>{name}</p>
//     </div>
//   );
// }

// function ChangePasswordDialog({ show, close }) {
//   const [currentPasswrd, setCurrentPassword] = useState();
//   const [newPassword, setNewPassword] = useState();
//   const [confirmPasswrd, setConfirmPassword] = useState();

//   const [passwordInputType, setPasswordInputType] = useState("password");
//   const [confirmPasswordInputType, setConfirmPasswordInputType] =
//     useState("password");
//   const [newPasswordInputType, setNewPasswordInputType] = useState("password");

//   async function performChangePassword() {
//     const response = await changePassword(currentPasswrd, newPassword);
//     if (response.success) {
//       toast("Password Updated", { type: "success" });
//       close();
//     } else {
//       toast("Password Update Failed", { type: "error" });
//     }
//   }

//   return (
//     <CustomDialog show={show} close={close}>
//       <Dialog.Panel
//         className={`w-full max-w-xl transform overflow-hidden rounded-2xl ${WhiteLinearGradient} p-6 text-left align-middle flex flex-col justify-center shadow-xl transition-all`}
//       >
//         <div className={`w-full flex justify-end items-end `}>
//           <IconButton
//             iconComponent={<Icon icon={"akar-icons:cross"} />}
//             className={`shadow-3xl flex justify-end ${WhiteLinearGradient} dark:text-primary-white`}
//             onClick={() => close()}
//           />
//         </div>
//         <p className="text-2xl font-bold text-center text-gray-900 dark:text-primary-white    ">
//           Change Password
//         </p>

//         <div className="mt-5 px-4 py-3 flex flex-row  rounded-lg items-center  border-[1px] bg-transparent border-gray-300 ">
//           <input
//             className="bg-transparent flex flex-1  placeholder-[#667085] outline-none"
//             placeholder="Current Password"
//             value={currentPasswrd}
//             type={passwordInputType}
//             onChange={(e) => {
//               if (e.target.value.length > 0)
//                 if (!e.target.value.match(/^[\S]+$/)) {
//                   toast("Spaces are not allowed in password");
//                 } else {
//                   setCurrentPassword(e.target.value);
//                 }
//               else {
//                 setCurrentPassword("");
//               }
//             }}
//           />
//           <Icon
//             icon={
//               passwordInputType === "password"
//                 ? "akar-icons:eye"
//                 : "akar-icons:eye-slashed"
//             }
//             color="#667085"
//             onClick={() => {
//               setPasswordInputType(
//                 passwordInputType === "password" ? "text" : "password"
//               );
//             }}
//             className="w-5 h-5"
//           />
//         </div>
//         <div className="mt-3 px-4 py-3 flex flex-row  rounded-lg items-center  border-[1px] bg-transparent border-gray-300 ">
//           <input
//             className="bg-transparent flex flex-1  placeholder-[#667085] outline-none"
//             placeholder="New Password"
//             value={newPassword}
//             type={newPasswordInputType}
//             onChange={(e) => {
//               if (e.target.value.length > 0)
//                 if (!e.target.value.match(/^[\S]+$/)) {
//                   toast("Spaces are not allowed in password");
//                 } else {
//                   setNewPassword(e.target.value);
//                 }
//               else {
//                 setNewPassword("");
//               }
//             }}
//           />
//           <Icon
//             icon={
//               newPasswordInputType === "password"
//                 ? "akar-icons:eye"
//                 : "akar-icons:eye-slashed"
//             }
//             color="#667085"
//             onClick={() => {
//               setNewPasswordInputType(
//                 newPasswordInputType === "password" ? "text" : "password"
//               );
//             }}
//             className="w-5 h-5"
//           />
//         </div>

//         <div className="mt-3 px-4 py-3 flex flex-row  rounded-lg items-center  border-[1px] bg-transparent border-gray-300 ">
//           <input
//             className="bg-transparent flex flex-1  placeholder-[#667085] outline-none"
//             placeholder="Confirm Password"
//             value={confirmPasswrd}
//             type={confirmPasswordInputType}
//             onChange={(e) => {
//               if (e.target.value.length > 0)
//                 if (!e.target.value.match(/^[\S]+$/)) {
//                   toast("Spaces are not allowed in password");
//                 } else {
//                   setConfirmPassword(e.target.value);
//                 }
//               else {
//                 setConfirmPassword("");
//               }
//             }}
//           />
//           <Icon
//             icon={
//               confirmPasswordInputType === "password"
//                 ? "akar-icons:eye"
//                 : "akar-icons:eye-slashed"
//             }
//             color="#667085"
//             onClick={() => {
//               setConfirmPasswordInputType(
//                 confirmPasswordInputType === "password" ? "text" : "password"
//               );
//             }}
//             className="w-5 h-5"
//           />
//         </div>
//         <Button
//           onClick={() => {
//             if (newPassword == confirmPasswrd) performChangePassword();
//             else toast("Password do not match");
//           }}
//           type="primary"
//           className={"self-center mt-6"}
//         >
//           Done
//         </Button>
//       </Dialog.Panel>
//     </CustomDialog>
//   );
// }

// function ProfileDetailItem({ title, value, className }) {
//   return (
//     <div className="flex flex-col md:flex-row md:space-x-10 md:items-center">
//       <p className="font-medium text-primary-gray uppercase flex md:basis-40">
//         {title}
//       </p>
//       <p
//         className={`font-medium text-lg md:text-xl ${BlackTextLinearGradient} ${className}`}
//       >
//         {value ? value : "-"}
//       </p>
//     </div>
//   );
// }

// function EditProfileDialog({ show, close }) {
//   const auth = useAuthContext();
//   const [name, setName] = useState(auth.state.user.fullname);
//   const [dob, setDob] = useState(
//     auth.state.user.dob
//       ? new Date(
//         auth.state.user.dob?.split("/")[2],
//         auth.state.user.dob?.split("/")[1] - 1,
//         auth.state.user.dob?.split("/")[0]
//       )
//       : null
//   );
//   const [height, setHeight] = useState(auth.state.user.height);
//   const [weight, setWeight] = useState(auth.state.user.weight);
//   const [heightUnit, setHeightUnit] = useState("cm");
//   const [weightUnit, setWeightUnit] = useState("KG");
//   const [feet, setFeet] = useState(Math.floor(height / 2.54 / 12));
//   const [inch, setInch] = useState(
//     (height / 2.54 - 12 * Math.floor(height / 2.54 / 12)).toFixed(2)
//   );
//   return (
//     <CustomDialog show={show} close={close}>
//       <Dialog.Panel
//         className={`w-full max-w-2xl transform overflow-hidden rounded-2xl ${WhiteLinearGradient} p-6 text-left align-middle shadow-xl transition-all`}
//       >
//         <div className="flex flex-row  items-center">
//           <p
//             className={`flex flex-1 font-medium text-xl ${BlackTextLinearGradient}`}
//           >
//             Edit Details
//           </p>
//           <IconButton
//             iconComponent={<Icon icon={"akar-icons:cross"} />}
//             className={`shadow-3xl flex justify-end ${WhiteLinearGradient} dark:text-primary-white`}
//             onClick={() => close()}
//           />
//         </div>
//         <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
//           <p className="font-medium basis-3/12 text-black dark:text-white uppercase">
//             Name
//           </p>
//           <input
//             className="px-4 py-3  rounded-lg border-[1px] dark:text-primary-white placeholder-[#667085] bg-transparent border-gray-300 "
//             placeholder="Name"
//             value={name}
//             onChange={(e) => {
//               setName(e.target.value);
//             }}
//           />
//         </div>
//         <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
//           <p className="font-medium basis-3/12 text-black dark:text-white uppercase">
//             Birthday
//           </p>
//           <div className="flex flex-row space-x-2 ">
//             <DatePicker
//               selected={dob}
//               onChange={(date) => setDob(date)}
//               dateFormat="dd/MM/yyyy"
//               allowSameDay={false}
//               endDate={new Date()}
//               maxDate={new Date()}
//               placeholderText="Date of Birth"
//               closeOnScroll={false}
//               showMonthDropdown
//               showYearDropdown
//               dropdownMode="select"
//               className="flex flex-1 px-4 w-full py-3 rounded-lg border-[1px] placeholder-[#667085] bg-transparent border-gray-300 text-black dark:text-white"
//             />
//           </div>
//         </div>
//         <div className="flex flex-col md:flex-row mt-4 md:items-center md:space-x-5">
//           <p className="font-medium basis-3/12 text-black dark:text-white text-lg">
//             Height
//           </p>
//           <div className="flex flex-row items-center md:space-x-2">
//             {heightUnit == "cm" && (
//               <input
//                 className="px-4 py-3 w-24 rounded-lg border-[1px] placeholder-customGray-700 text-black dark:text-white bg-transparent border-customGray-700 "
//                 placeholder={heightUnit}
//                 value={height}
//                 onChange={(e) => {
//                   setHeight(e.target.value);
//                 }}
//                 type="number"
//               />
//             )}
//             <div className="flex flex-col md:flex-row w-full gap-5">
//               {heightUnit == "ft" && (
//                 <input
//                   className="px-4 py-3 w-24 rounded-lg border-[1px] placeholder-customGray-700 text-black dark:text-white bg-transparent border-customGray-700 "
//                   placeholder={"Ft."}
//                   value={feet}
//                   onChange={(e) => {
//                     setFeet(e.target.value);

//                     setHeight(
//                       (30.48 * e.target.value + inch * 2.54).toFixed(2)
//                     );
//                   }}
//                   type="number"
//                 />
//               )}
//               {heightUnit == "ft" && (
//                 <input
//                   className="px-4 py-3 w-24 rounded-lg border-[1px] placeholder-customGray-700 text-black dark:text-white bg-transparent border-customGray-700 "
//                   placeholder={"Inc."}
//                   value={inch}
//                   onChange={(e) => {
//                     setInch(e.target.value);
//                     setHeight(
//                       (feet * 30.54 + e.target.value * 2.54).toFixed(2)
//                     );
//                   }}
//                   type="number"
//                 />
//               )}
//             </div>
//             <div className="flex flex-row items-center gap-5 mt-5 md:mt-0">
//               <p
//                 className={`${heightUnit == "cm"
//                   ? "text-primary-orange"
//                   : "text-primary-gray"
//                   } font-medium`}
//               >
//                 CENT.
//               </p>
//               <Switch
//                 checked={heightUnit == "ft"}
//                 onChange={(checked) => {
//                   if (checked) {
//                     setHeightUnit("ft");
//                   } else {
//                     setHeightUnit("cm");
//                   }

//                   if (checked) {
//                     setFeet(Math.floor(height / 2.54 / 12));
//                     setInch(
//                       (
//                         height / 2.54 -
//                         12 * Math.floor(height / 2.54 / 12)
//                       ).toFixed(2)
//                     );
//                   }
//                 }}
//                 className={`bg-primary-orange
//           relative items-center inline-flex h-[20px] w-[35px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
//               >
//                 <span
//                   aria-hidden="true"
//                   className={`${heightUnit == "ft" ? "translate-x-4" : "-translate-x-2"
//                     }
//             pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
//                 >
//                   <span
//                     aria-hidden="true"
//                     className={`${heightUnit == "ft" ? "translate-x-0" : "-translate-x-0"
//                       }
//             pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
//                   />
//                 </span>
//               </Switch>

//               <p
//                 className={`${heightUnit == "ft"
//                   ? "text-primary-orange"
//                   : "text-primary-gray"
//                   } font-medium`}
//               >
//                 FT.
//               </p>
//             </div>
//           </div>
//         </div>
//         <div className="flex flex-col md:flex-row mt-4 md:items-center md:space-x-5">
//           <p className="font-medium basis-3/12 text-black dark:text-white text-lg">
//             Weight
//           </p>
//           <div className="flex flex-row items-center space-x-2">
//             <input
//               className="px-4 py-3 w-24 rounded-lg border-[1px] placeholder-customGray-700 text-black dark:text-white bg-transparent border-customGray-700 "
//               placeholder={weightUnit}
//               value={weight}
//               onChange={(e) => {
//                 setWeight(e.target.value);
//               }}
//               type="number"
//             />
//             <p
//               className={`${weightUnit == "KG" ? "text-primary-orange" : "text-primary-gray"
//                 } font-medium`}
//             >
//               KG.
//             </p>
//             <Switch
//               checked={weightUnit == "lbs"}
//               onChange={(checked) => {
//                 if (checked) {
//                   setWeightUnit("lbs");
//                 } else {
//                   setWeightUnit("KG");
//                 }
//                 if (checked) {
//                   setWeight((weight / 0.453592).toFixed(2));
//                 } else {
//                   setWeight((weight * 0.453592).toFixed(2));
//                 }
//               }}
//               className={`bg-primary-orange
//           relative items-center inline-flex h-[20px] w-[35px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
//             >
//               <span
//                 aria-hidden="true"
//                 className={`${weightUnit == "lbs" ? "translate-x-4" : "-translate-x-2"
//                   }
//             pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
//               >
//                 <span
//                   aria-hidden="true"
//                   className={`${weightUnit == "lbs" ? "translate-x-0" : "-translate-x-0"
//                     }
//             pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
//                 />
//               </span>
//             </Switch>
//             <p
//               className={`${weightUnit == "lbs"
//                 ? "text-primary-orange"
//                 : "text-primary-gray"
//                 } font-medium`}
//             >
//               LBS.
//             </p>
//           </div>
//         </div>
//         <div className="flex justify-center">
//           <Button
//             onClick={async () => {
//               if (!height || height < 0) {
//                 toast("Height is required", { type: "error" });
//               } else if (
//                 heightUnit != "cm" &&
//                 (feet < 2 || feet > 7 || inch < 0 || inch > 12)
//               ) {
//                 toast("Height must be between 2 and 7 ft.", {
//                   type: "error",
//                 });
//               } else if (heightUnit != "ft" && (height < 2 || height > 213)) {
//                 toast("Height must be between 30 cm and 213 cm.", {
//                   type: "error",
//                 });
//               } else if (!weight) {
//                 toast("Weight is required", { type: "error" });
//               } else if (weight <= 1) {
//                 toast("Weight must be greater than 1", { type: "error" });
//               } else if (weightUnit == "lbs" && (weight < 4 || weight > 331)) {
//                 toast("Weight must be between 4 and 331 lbs.", {
//                   type: "error",
//                 });
//               } else if (weightUnit != "lbs" && (weight < 4 || weight > 150)) {
//                 toast("Weight must be between 4 and 150 kgs.", {
//                   type: "error",
//                 });
//               } else if (dob == null) {
//                 toast("Invalid Date of Birth", { type: "error" });
//               } else {
//                 let response = await getBmi({
//                   height: height,
//                   weight: weight,
//                   dob: dob
//                     .toLocaleString("en-us", {
//                       year: "numeric",
//                       month: "2-digit",
//                       day: "2-digit",
//                     })
//                     .replace(/(\d+)\/(\d+)\/(\d+)/, "$2/$1/$3"),
//                 });
//                 const data = {
//                   update: JSON.stringify({
//                     fullname: name,
//                   }),
//                 };
//                 response = await updateUserProfile(data);
//                 auth.updateUser();
//                 toast("Profile details updated");
//                 close();
//               }
//             }}
//             type="primary"
//             className={"w-2/5 mt-6"}
//           >
//             Done
//           </Button>
//         </div>
//       </Dialog.Panel>
//     </CustomDialog>
//   );
// }

// const MemoizedBmiGauge = React.memo(BmiGauge);

// function BmiGauge({ bmi }) {
//   return (
//     <GaugeChart
//       id="bmi-chart"
//       nrOfLevels={4}
//       colors={["#F6D738", "#34E130", "#FE654F", "#FF0000"]}
//       arcPadding={0}
//       cornerRadius={0}
//       needleBaseColor={"#3E0CA7"}
//       needleColor={"#0B28AC"}
//       hideText
//       percent={bmi ? (bmi / 50 > 1 ? 1 : bmi / 50) : 0}
//       arcsLength={[0.35, 0.2, 0.25, 0.25]}
//     />
//   );
// }

// function BMIComponent({ profile, onUpdateProfile }) {
//   const auth = useAuthContext();

//   const [height, setHeight] = useState(auth.state.user.height);
//   const [weight, setWeight] = useState(auth.state.user.weight);
//   const [heightUnit, setHeightUnit] = useState("cm");
//   const [weightUnit, setWeightUnit] = useState("KG");
//   const [feet, setFeet] = useState(Math.floor(height / 2.54 / 12));
//   const [inch, setInch] = useState(
//     (height / 2.54 - 12 * Math.floor(height / 2.54 / 12)).toFixed(2)
//   );
//   return (
//     <div
//       className={`border-[#B6BCDA80] dark:border-[#68696B33] border-[1px] ${WhiteLinearGradient} rounded-xl py-3 px-6`}
//     >
//       <div className="flex flex-col md:flex-row my-3 md:my-7 md:space-x-5">
//         <div className="flex flex-col text-xl font-bold  w-full md:w-32 basis-1/4">
//           <p className={`text-2xl font-medium mb-5 ${BlackTextLinearGradient}`}>
//             Your BMI
//           </p>
//           <MemoizedBmiGauge bmi={profile.bmi} />
//           <p className="text-primary-black dark:text-primary-white text-4xl text-center">
//             {profile.bmi}
//           </p>
//           <BMIRange
//             name={
//               profile.bmi > 30
//                 ? "Obese"
//                 : profile.bmi >= 25
//                   ? "Over Weight"
//                   : profile.bmi >= 18.5
//                     ? "Healthy"
//                     : "Under Weight"
//             }
//             color={
//               profile.bmi > 30
//                 ? "bg-[#ED2114]"
//                 : profile.bmi >= 25
//                   ? "bg-gradient-to-bl from-[#F27128] to-[#E1AF30E8]"
//                   : profile.bmi >= 18.5
//                     ? "bg-gradient-to-bl from-[#34E130] to-[#30A1E1E8]"
//                     : "bg-gradient-to-bl from-[#E1CF30] to-[#C8E130E8]"
//             }
//           />
//         </div>

//         <div
//           className={`min-w-[1px] min-h-full bg-gradient-to-b from-primary-white via-primary-black to-primary-white`}
//         ></div>
//         <div
//           className={`block md:hidden min-h-[1px] min-w-full bg-gradient-to-l my-10 from-primary-white via-primary-black to-primary-white`}
//         ></div>
//         <div className="flex flex-col flex-1">
//           <div className="flex flex-row space-x-10">
//             <p
//               className={`text-2xl flex-1 font-medium mb-5 ${BlackTextLinearGradient}`}
//             >
//               Your BMR
//             </p>
//             <Button
//               type="primary"
//               className={"hidden md:block max-h-max"}
//               onClick={async () => {
//                 if (!height || height < 0) {
//                   toast("Height is required", { type: "error" });
//                 } else if (
//                   heightUnit != "cm" &&
//                   (feet < 2 || feet > 7 || inch < 0 || inch > 12)
//                 ) {
//                   toast("Height must be between 2 and 7 ft.", {
//                     type: "error",
//                   });
//                 } else if (heightUnit != "ft" && (height < 2 || height > 213)) {
//                   toast("Height must be between 30 cm and 213 cm.", {
//                     type: "error",
//                   });
//                 } else if (!weight) {
//                   toast("Weight is required", { type: "error" });
//                 } else if (weight <= 1) {
//                   toast("Weight must be greater than 1", { type: "error" });
//                 } else if (
//                   weightUnit == "lbs" &&
//                   (weight < 4 || weight > 331)
//                 ) {
//                   toast("Weight must be between 4 and 331 lbs.", {
//                     type: "error",
//                   });
//                 } else if (
//                   weightUnit != "lbs" &&
//                   (weight < 4 || weight > 150)
//                 ) {
//                   toast("Weight must be between 4 and 150 kgs.", {
//                     type: "error",
//                   });
//                 } else {
//                   const response = await getBmi({
//                     height: height,
//                     weight: weight,
//                     dob: profile.dob,
//                   });
//                   if (response.bmi) {
//                     toast("BMR updated");
//                   } else {
//                     toast("BMR udpate failed");
//                   }
//                   onUpdateProfile();
//                 }
//               }}
//             >
//               <div className="flex flex-row space-x-3 items-center">
//                 <p className={`font-bold`}>Update Data</p>
//                 <Icon icon="jam:refresh-reverse" className="h-6 w-auto" />
//               </div>
//             </Button>
//           </div>
//           <p className={`text-2xl font-medium mb-5 `}>
//             <span className="text-[#9EDB00]">{profile.bmr}</span>{" "}
//             <span className="dark:text-primary-white">Calories/Day</span>{" "}
//           </p>
//           <div className="flex flex-col md:flex-row mt-4 md:items-center md:space-x-5">
//             <p className="font-medium basis-3/12 text-black dark:text-white text-lg">
//               Height
//             </p>
//             <div className="flex flex-row items-center md:space-x-2">
//               {heightUnit == "cm" && (
//                 <input
//                   className="px-4 py-3 w-24 rounded-lg border-[1px] placeholder-customGray-700 text-black dark:text-white bg-transparent border-customGray-700 "
//                   placeholder={heightUnit}
//                   value={height}
//                   onChange={(e) => {
//                     setHeight(e.target.value);
//                   }}
//                   type="number"
//                 />
//               )}
//               <div className="flex flex-col md:flex-row w-full gap-5">
//                 {heightUnit == "ft" && (
//                   <input
//                     className="px-4 py-3 w-24 rounded-lg border-[1px] placeholder-customGray-700 text-black dark:text-white bg-transparent border-customGray-700 "
//                     placeholder={"Ft."}
//                     value={feet}
//                     onChange={(e) => {
//                       setFeet(e.target.value);

//                       setHeight(
//                         (30.48 * e.target.value + inch * 2.54).toFixed(2)
//                       );
//                     }}
//                     type="number"
//                   />
//                 )}
//                 {heightUnit == "ft" && (
//                   <input
//                     className="px-4 py-3 w-24 rounded-lg border-[1px] placeholder-customGray-700 text-black dark:text-white bg-transparent border-customGray-700 "
//                     placeholder={"Inc."}
//                     value={inch}
//                     onChange={(e) => {
//                       setInch(e.target.value);
//                       setHeight(
//                         (feet * 30.54 + e.target.value * 2.54).toFixed(2)
//                       );
//                     }}
//                     type="number"
//                   />
//                 )}
//               </div>
//               <div className="flex flex-row items-center gap-5 mt-5 md:mt-0">
//                 <p
//                   className={`${heightUnit == "cm"
//                     ? "text-primary-orange"
//                     : "text-primary-gray"
//                     } font-medium`}
//                 >
//                   CENT.
//                 </p>
//                 <Switch
//                   checked={heightUnit == "ft"}
//                   onChange={(checked) => {
//                     if (checked) {
//                       setHeightUnit("ft");
//                     } else {
//                       setHeightUnit("cm");
//                     }

//                     if (checked) {
//                       setFeet(Math.floor(height / 2.54 / 12));
//                       setInch(
//                         (
//                           height / 2.54 -
//                           12 * Math.floor(height / 2.54 / 12)
//                         ).toFixed(2)
//                       );
//                     }
//                   }}
//                   className={`bg-primary-orange
//           relative items-center inline-flex h-[20px] w-[35px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
//                 >
//                   <span
//                     aria-hidden="true"
//                     className={`${heightUnit == "ft" ? "translate-x-4" : "-translate-x-2"
//                       }
//             pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
//                   >
//                     <span
//                       aria-hidden="true"
//                       className={`${heightUnit == "ft" ? "translate-x-0" : "-translate-x-0"
//                         }
//             pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
//                     />
//                   </span>
//                 </Switch>

//                 <p
//                   className={`${heightUnit == "ft"
//                     ? "text-primary-orange"
//                     : "text-primary-gray"
//                     } font-medium`}
//                 >
//                   FT.
//                 </p>
//               </div>
//             </div>
//           </div>
//           <div className="flex flex-col md:flex-row mt-4 md:items-center md:space-x-5">
//             <p className="font-medium basis-3/12 text-black dark:text-white text-lg">
//               Weight
//             </p>
//             <div className="flex flex-row items-center space-x-2">
//               <input
//                 className="px-4 py-3 w-24 rounded-lg border-[1px] placeholder-customGray-700 text-black dark:text-white bg-transparent border-customGray-700 "
//                 placeholder={weightUnit}
//                 value={weight}
//                 onChange={(e) => {
//                   setWeight(e.target.value);
//                 }}
//                 type="number"
//               />
//               <p
//                 className={`${weightUnit == "KG"
//                   ? "text-primary-orange"
//                   : "text-primary-gray"
//                   } font-medium`}
//               >
//                 KG.
//               </p>
//               <Switch
//                 checked={weightUnit == "lbs"}
//                 onChange={(checked) => {
//                   if (checked) {
//                     setWeightUnit("lbs");
//                   } else {
//                     setWeightUnit("KG");
//                   }
//                   if (checked) {
//                     setWeight((weight / 0.453592).toFixed(2));
//                   } else {
//                     setWeight((weight * 0.453592).toFixed(2));
//                   }
//                 }}
//                 className={`bg-primary-orange
//           relative items-center inline-flex h-[20px] w-[35px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
//               >
//                 <span
//                   aria-hidden="true"
//                   className={`${weightUnit == "lbs" ? "translate-x-4" : "-translate-x-2"
//                     }
//             pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
//                 >
//                   <span
//                     aria-hidden="true"
//                     className={`${weightUnit == "lbs" ? "translate-x-0" : "-translate-x-0"
//                       }
//             pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
//                   />
//                 </span>
//               </Switch>
//               <p
//                 className={`${weightUnit == "lbs"
//                   ? "text-primary-orange"
//                   : "text-primary-gray"
//                   } font-medium`}
//               >
//                 LBS.
//               </p>
//             </div>
//           </div>
//           <Button
//             type="primary"
//             className={
//               "block md:hidden flex max-h-max items-center space-x-3 mt-5"
//             }
//             onClick={async () => {
//               if (!height || height < 0) {
//                 toast("Height is required", { type: "error" });
//               } else if (
//                 heightUnit != "cm" &&
//                 (feet < 2 || feet > 7 || inch < 0 || inch > 12)
//               ) {
//                 toast("Height must be between 2 and 7 ft.", {
//                   type: "error",
//                 });
//               } else if (heightUnit != "ft" && (height < 2 || height > 213)) {
//                 toast("Height must be between 30 cm and 213 cm.", {
//                   type: "error",
//                 });
//               } else if (!weight) {
//                 toast("Weight is required", { type: "error" });
//               } else if (weight <= 1) {
//                 toast("Weight must be greater than 1", { type: "error" });
//               } else if (weightUnit == "lbs" && (weight < 4 || weight > 331)) {
//                 toast("Weight must be between 4 and 331 lbs.", {
//                   type: "error",
//                 });
//               } else if (weightUnit != "lbs" && (weight < 4 || weight > 150)) {
//                 toast("Weight must be between 4 and 150 kgs.", {
//                   type: "error",
//                 });
//               } else {
//                 console.log({ height, weight });

//                 const response = await getBmi({
//                   height: height,
//                   weight: weight,
//                   dob: profile.dob,
//                 });
//                 if (response.bmi) {
//                   toast("BMR updated");
//                 } else {
//                   toast("BMR udpate failed");
//                 }
//                 onUpdateProfile();
//               }
//             }}
//           >
//             <p className={`font-bold`}>Update Data</p>
//             <Icon icon="jam:refresh-reverse" className="h-6 w-auto" />
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// }

// function ProfilePage() {
//   const auth = useAuthContext();
//   const navigate = useNavigate();

//   const [profile, setProfile] = useState({});
//   const [showChangePassword, setShowChangePassword] = useState(false);
//   const [showEditProfile, setShowEditProfile] = useState(false);
//   const [showImageCropper, setShowImageCropper] = useState(false);
//   const [profilePicture, setProfilePicture] = useState();
//   const imagePickerRef = useRef();

//   async function updateProfile() {
//     let response = await getProfile();
//     if (response) {
//       setProfile(response);
//     } else {
//       toast("Error fetching profile details", { type: "error" });
//     }
//   }

//   async function uploadAvatar(image) {
//     let data = new FormData();
//     data.append("avatar", image);
//     const response = await updateAvatar(data);
//     auth.updateUser();
//     if (response.success) {
//       toast("Avatar Updated");
//       return true;
//     } else {
//       toast("Avatar update failed. Try a different image");
//       return false;
//     }
//   }

//   useEffect(() => {
//     updateProfile();
//   }, []);

//   return (
//     <div
//       className={`w-full h-full px-10 py-28 lg:px-52 2xl:px-80 space-y-8 ${WhiteLinearGradient}`}
//     >
//       <ImageCropDialog
//         show={showImageCropper}
//         close={async (croppedImageBlob) => {
//           setShowImageCropper(false);
//           const croppedImageUrl = window.URL.createObjectURL(croppedImageBlob);
//           const file = new File([croppedImageBlob], "image.png", {
//             type: croppedImageBlob.type,
//           });
//           const success = await uploadAvatar(file);
//         }}
//         image={profilePicture}
//         aspectRatio={1}
//       />
//       <div className="flex flex-col md:flex-row md:space-x-10 items-center md:items-start space-y-6 md:space-y-0">
//         <div className="relative w-44 h-44">
//           {auth.state.user.avatar ? (
//             <img
//               src={auth.state.user.avatar}
//               className="absolute object-cover rounded-full h-44 w-44"
//             />
//           ) : (
//             <div
//               className={`${BlueLinearGradient} rounded-full h-44 w-44 flex items-center justify-center`}
//             >
//               <p className={`font-medium text-8xl ${WhiteTextLinearGradient}`}>
//                 {auth.state.user.fullname[0]}
//               </p>
//             </div>
//           )}

//           <Icon
//             icon="clarity:edit-line"
//             className={`absolute bottom-2 right-5 bg-primary-blue w-8 h-8 p-2 rounded-full text-white`}
//             onClick={() => {
//               imagePickerRef.current.click();
//             }}
//           />
//           <input
//             type="file"
//             id="file"
//             ref={imagePickerRef}
//             className="hidden"
//             onChange={(e) => {
//               const image = e.target.files[0];
//               if (image) {
//                 setProfilePicture(image);
//                 setShowImageCropper(true);
//               }
//             }}
//           />
//         </div>
//         <div className="flex flex-col flex-1 items-center md:items-start">
//           <p className="text-black dark:text-white font-medium text-2xl md:text-3xl">
//             {auth.state.user.fullname}
//           </p>
//           <p className="text-primary-gray dark:text-gray-400 font-medium md:text-2xl">
//             {auth.state.user.email}
//           </p>
//           <p className="text-primary-gray text-sm md:text-base">
//             Joined on {timestampToFormattedDate(auth.state.user.createdAt)}
//           </p>
//         </div>
//         <div className="flex flex-col justify-center items-center w-60 h-full p-7 space-y-1 rounded-xl bg-gradient-to-b from-[#3E0CA7B2] to-[#0B28ACB2]">
//           <Icon
//             icon="akar-icons:clock"
//             className="h-11 w-11 text-primary-white"
//           />
//           <p className={`font-bold text-4xl  ${WhiteTextLinearGradient} `}>
//             {profile.timespent}
//           </p>
//           <p className={`font-medium  ${WhiteTextLinearGradient} `}>
//             {profile.timespent > 1 ? "MINUTE" : "MINUTES"} SPENT
//           </p>
//         </div>
//       </div>
//       <BMIComponent
//         profile={profile}
//         onUpdateProfile={() => {
//           updateProfile();
//           auth.updateUser();
//         }}
//       />
//       <div
//         className={`border-[#B6BCDA80] dark:border-[#68696B33] border-[1px] ${WhiteLinearGradient} rounded-xl p-4 md:p-9`}
//       >
//         <ChangePasswordDialog
//           show={showChangePassword}
//           close={() => setShowChangePassword(false)}
//         />
//         <EditProfileDialog
//           show={showEditProfile}
//           close={() => {
//             updateProfile();
//             setShowEditProfile(false);
//           }}
//         />
//         <div className="flex flex-row items-center space-x-2 md:space-x-6">
//           <p
//             className={`flex flex-1 font-medium text-2xl ${BlackTextLinearGradient}`}
//           >
//             Details
//           </p>
//           {auth.state?.user?.verifiedThrough == "email" && (
//             <Button
//               type="outline"
//               className={
//                 "hidden md:block flex items-center space-x-3 border-primary-black dark:border-primary-white"
//               }
//               onClick={() => setShowChangePassword(true)}
//             >
//               <p className={`${BlackTextLinearGradient} font-bold`}>
//                 Change Password
//               </p>
//             </Button>
//           )}

//           <Button
//             type="primary"
//             className={"  flex items-center space-x-3 "}
//             onClick={() => setShowEditProfile(true)}
//           >
//             <p className={` font-bold`}>Edit</p>
//             <Icon icon="clarity:edit-line" className="h-4 w-auto" />
//           </Button>
//         </div>

//         <div className="flex flex-col py-5 md:p-5 space-y-5">
//           <ProfileDetailItem title={"Name"} value={auth.state.user.fullname} />
//           <ProfileDetailItem title={"Email"} value={auth.state.user.email} />
//           <ProfileDetailItem title={"Mobile"} value={auth.state.user.mobile} />
//           <ProfileDetailItem title={"Birthday"} value={auth.state.user.dob} />
//           <ProfileDetailItem
//             title={"Gender"}
//             value={auth.state.user.gender}
//             className="capitalize"
//           />
//           <ProfileDetailItem
//             title={"Height"}
//             value={auth.state.user.height + " cm"}
//           />
//           <ProfileDetailItem
//             title={"Weight"}
//             value={auth.state.user.weight + " kg"}
//           />
//           {/* <ProfileDetailItem
//             title={"Fitness Level"}
//             value={auth.state.user.fitnessLevel}
//           />
//           <ProfileDetailItem
//             title={"Goal"}
//             value={
//               auth.state.user.goal == 0
//                 ? "Starting Out"
//                 : auth.state.user.goal == 1
//                 ? "Casual Gym Goer"
//                 : auth.state.user.goal == 2
//                 ? "Fitness Freak"
//                 : ""
//             }
//           /> */}
//         </div>

//         {auth.state?.user?.verifiedThrough == "email" && (
//           <div className="block md:hidden">
//             <Button
//               type="outline"
//               className={
//                 " flex items-center space-x-3 border-primary-black dark:border-primary-white"
//               }
//               onClick={() => setShowChangePassword(true)}
//             >
//               <p className={`${BlackTextLinearGradient} font-bold`}>
//                 Change Password
//               </p>
//             </Button>
//           </div>
//         )}
//       </div>
//       {showTrailExpireAnnouncement(auth.state.user) && (
//         <div
//           className={`flex flex-row justify-center items-center space-x-4 bg-primary-orange rounded-xl p-4 md:p-9`}
//         >
//           <p className="text-white text-xl">
//             {getExpiresInDays(auth.state.user.expiresAt) <= 0
//               ? "Your Plan has expired"
//               : `Your ${auth.state.user.trail ? "free" : ""
//               } plan expires in ${getExpiresInDays(
//                 auth.state.user.expiresAt
//               )} Days`}
//           </p>
//           <Button
//             type="outline"
//             className={" border-white"}
//             onClick={() => navigate("/subscription")}
//           >
//             <p className="text-white">View Plans</p>
//           </Button>
//         </div>
//       )}
//     </div>
//   );
// }

// export default ProfilePage;

// Header edit
// <EditProfileDialog
//   show={showEditProfile}
//   close={() => {
//     updateProfile();
//     setShowEditProfile(false);
//   }}
// />
// <div
//   type="primary"
//   className={"flex absolute right-4 flex-row items-end lg:-mt-1 mb-6 text-primary-gray space-x-1.5 space-y-3 ml-10 p-4"}
//   onClick={() => setShowEditProfile(true)}
// >
//   <Icon icon="clarity:edit-line" className="h-3 w-auto flex justify-end" />
//   <p className={`font-light text-xs`}>edit</p>
// </div>
